let activeModal = null;
let activeModalTrigger = null;

function triggersFor(modal) {
  return Array.from(document.querySelectorAll(".js-modal-trigger")).filter(
    (trigger) => trigger.dataset.target === modal.id
  );
}

function closeModal(modal = activeModal, { restoreFocus = true } = {}) {
  if (!modal) return;

  modal.classList.remove("is-active");
  modal.setAttribute("aria-hidden", "true");
  triggersFor(modal).forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));

  if (modal === activeModal) {
    const trigger = activeModalTrigger;
    activeModal = null;
    activeModalTrigger = null;
    document.documentElement.classList.remove("is-clipped");

    if (restoreFocus && trigger?.isConnected) trigger.focus();
  }
}

function openModal(modal, trigger) {
  if (!modal) return;

  if (activeModal && activeModal !== modal) closeModal(activeModal, { restoreFocus: false });

  activeModal = modal;
  activeModalTrigger = trigger;
  modal.classList.add("is-active");
  modal.setAttribute("aria-hidden", "false");
  triggersFor(modal).forEach((item) => item.setAttribute("aria-expanded", "true"));
  document.documentElement.classList.add("is-clipped");

  window.requestAnimationFrame(() => {
    const focusTarget = modal.querySelector("[data-modal-autofocus]") || modal.querySelector("button, input, select, textarea");
    focusTarget?.focus();
  });
}

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(".js-modal-trigger");

  if (trigger) {
    event.preventDefault();
    openModal(document.getElementById(trigger.dataset.target), trigger);
    return;
  }

  const closeControl = event.target.closest("[data-modal-close], .modal-close, .modal-card-head .delete");
  const footerButton = event.target.closest(".modal-card-foot .button");
  const footerClose = footerButton && !(footerButton.type === "submit" && footerButton.form) ? footerButton : null;
  const backdrop = event.target.closest(".modal-background");

  if (closeControl || footerClose || backdrop) {
    event.preventDefault();
    closeModal((closeControl || footerClose || backdrop).closest(".modal"));
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;

  if (activeModal) {
    closeModal();
  } else {
    document.querySelectorAll(".modal.is-active").forEach((modal) => closeModal(modal));
  }
});

document.addEventListener("turbo:before-cache", () => closeModal(activeModal, { restoreFocus: false }));
